module.exports = __webpack_public_path__ + "media/images/features/3/feature-3-item-option-ae1bec359e89c5fd45933a6bf5372670.png";